import { SHIPPING_QUOTE, RESPONSE_STATUS, CLEAR_RESPONSE } from './artaTypes'
export default (state, action) => {
    switch (action.type) {
        case SHIPPING_QUOTE:
            return {
                ...state,
                shipping_quotes: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
